<template>
    <div class="general-data-config">
        <h1>Configuration des données générales</h1>

        <div v-for="([key, items]) in sortedChapters" :key="key" class="chapter-block">
            Sélectionner tout le chapitre <input :disabled="isLocked" type="checkbox" @change="toggleChapter(items, $event.target.checked)" :checked="isChapterChecked(items)"/>
        <h2>{{ key }}</h2>
            <table>
                <tbody>
                    <tr v-for="(item) in items" :key="item.tag"> <td>
                            <input @change="toggleSelected(item.tag, item.is_visible)" :disabled="isLocked" type="checkbox" v-model="item.is_visible" />
                        </td>
                        <td>{{item.tag}}</td>
                        <td v-html="item.description"/>
                        <td v-html="item.unit"/>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- <h2>EQUIPE DE PROJET</h2>
        <table>
            <thead>
                <tr>
                    <th></th>
                    <th v-for="(header, index) in teamHeader" :key="index">{{ header }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(row, rowIndex) in team" :key="rowIndex">
                    <td>
                        <input type="checkbox" v-model="team[rowIndex].isSelected" />
                    </td>
                    <td v-html="team[rowIndex].data[cellIndex]" v-for="(cell, cellIndex) in row.data" :key="cellIndex" />
                </tr>
            </tbody>
        </table>

        <h2>LOCALISATION</h2>
        <table>
            <thead>
                <tr>
                    <th></th>
                    <th v-for="(header, index) in localisationHeader" :key="index">{{ header }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(row, rowIndex) in localisation" :key="rowIndex">
                    <td>
                        <input type="checkbox" v-model="localisation[rowIndex].isSelected" />
                    </td>
                    <td v-html="localisation[rowIndex].data[cellIndex]" v-for="(cell, cellIndex) in row.data" :key="cellIndex" />
                </tr>
            </tbody>
        </table>

        <h2>SURFACES</h2>
        <table>
            <thead>
                <tr>
                    <th></th>
                    <th v-for="(header, index) in surfaceHeader" :key="index">{{ header }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(row, rowIndex) in surfaces" :key="rowIndex">
                    <td>
                        <input type="checkbox" v-model="surfaces[rowIndex].isSelected" />
                    </td>
                    <td v-html="surfaces[rowIndex].data[cellIndex]" v-for="(cell, cellIndex) in row.data" :key="cellIndex" />
                </tr>
            </tbody>
        </table>

        <h2>CIBLES</h2>
        <table>
            <thead>
                <tr>
                    <th></th>
                    <th v-for="(header, index) in targetHeader" :key="index">{{ header }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(row, rowIndex) in target" :key="rowIndex">
                    <td>
                        <input @change="updateVisibility()" type="checkbox" v-model="target[rowIndex].isSelected" />
                    </td>
                    <td v-html="target[rowIndex].data[cellIndex]" v-for="(cell, cellIndex) in row.data" :key="cellIndex" />
                </tr>
            </tbody>
        </table> -->
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import '../../assets/styles/table.css';

export default {
    name: 'GeneralDataConfig',
    data() {
        return {
            chapters: [],
            checked:true,
            teamHeader: [
                'EQUIPE DE PROJET', 'ENTITÉ ET FONCTION', 'ADRESSE', 'NPA', 'LOCALITE', 'NOM', 'PRENOM', 'TEL.', 'EMAIL'
            ],
            team: [
                { isSelected: false, data: ['MAITRE DE L\'OUVRAGE', '', '', '', '', '', '', '', ''] },
                { isSelected: false, data: ['MAITRES DE L\'OUVRAGE', '', '', '', '', '', '', '', ''] },
                { isSelected: false, data: ['ARCHITECTE', '', '', '', '', '', '', '', ''] },
                { isSelected: false, data: ['PLANIFICATEURS', '', '', '', '', '', '', '', ''] },
                { isSelected: false, data: ['REPRÉSENTANTS DES AUTORITÉS', '', '', '', '', '', '', '', ''] },
                { isSelected: false, data: ['INGENIEUR CVC', '', '', '', '', '', '', '', ''] },
                { isSelected: false, data: ['INGENIEUR TRAFIC', '', '', '', '', '', '', '', ''] },
                { isSelected: false, data: ['INGENIEUR ENVIRONNEMENT', '', '', '', '', '', '', '', ''] },
                { isSelected: false, data: ['INGENIEUR ENERGIE', '', '', '', '', '', '', '', ''] }
            ],
            localisationHeader: [
                'Description'
            ],
            localisation: [
                { isSelected: false, data: ['DENOMINATION DU BÂTIMENT'] },
                { isSelected: false, data: ['DENOMINATION DU QUARTIER'] },
                { isSelected: false, data: ['ADRESSE'] },
                { isSelected: false, data: ['NPA, LOCALITE'] }
            ],
            surfaceHeader: [
                'Description', 'UNITÉ'
            ],
            surfaces: [
                { isSelected: false, data: ['SURFACE DU PÉRIMÈTRE CONSTRUCTIBLE (OU DU DDP)', 'm<sup>2</sup> ST'] },
                { isSelected: false, data: ['SURFACE DÉTERMINANTE DES CONSTRUCTIONS', 'm<sup>2</sup> SC'] },
                { isSelected: false, data: ['SURFACE DE PLANCHER','m<sup>2</sup> SP'] },
                { isSelected: false, data: ['SURFACE DE PLANCHER DÉTERMINANTE','m<sup>2</sup> SPd'] },
                { isSelected: false, data: ['SURFACE UTILE PRINCIPALE','m<sup>2</sup> SUP'] },
                { isSelected: false, data: ['SURFACE UTILE SECONDAIRE','m<sup>2</sup> SUS'] },
                { isSelected: false, data: ['SURFACE D\'INSTALLATION','m<sup>2</sup> SI'] },
                { isSelected: false, data: ['VOLUME BATI (VB)','m<sup>3</sup>'] },
                { isSelected: false, data: ['VOLUME DES SOUS-SOLS','m<sup>3</sup>'] }
            ],
            targetHeader: [
                'Description', 'UNITÉ'
            ],
            target: [
                { isSelected: false, data: ['COÛT TOTAL HORS TERRAIN PAR m<sup>2</sup> SUP','CHF TTC/m<sup>2</sup> SUP'] },
                { isSelected: false, data: ['PRIX DE VENTE CIBLE DE LOGEMENTS EN PPE PAR m<sup>2</sup> SUP','CHF/m<sup>2</sup> SUP'] },
                { isSelected: false, data: ['LOYER CIBLE DES LOGEMENTS MARCHÉ LIBRE PAR m<sup>2</sup> SUP','CHF/m<sup>2</sup> SUP an'] },
                { isSelected: false, data: ['LOYER CIBLE DES LOGEMENTS LLA PAR m<sup>2</sup> SUP','CHF/m<sup>2</sup> SUP an'] },
                { isSelected: false, data: ['LOYER CIBLE DES LOGEMENTS LLM PAR m<sup>2</sup> SUP','CHF/m<sup>2</sup> SUP an'] },
                { isSelected: false, data: ['PRIX DE VENTE CIBLE DES SURFACES D\'ACTIVITÉS EN PPE PAR m<sup>2</sup> SUP','CHF/m<sup>2</sup> SUP'] },
                { isSelected: false, data: ['LOYER CIBLE DES SURFACES D\'ACTIVITÉS PAR m<sup>2</sup> SUP','CHF/m<sup>2</sup> SUP an'] },
                { isSelected: false, data: ['PRIX DU TERRAIN','CHF/SPd'] },
                { isSelected: false, data: ['RENTE ANNUELLE DE DDP (DROIT DISTINCT ET PERMANENT DE SUPERFICIE)','CHF/an'] },
                { isSelected: false, data: ['RENTE UNIQUE DE DDP (DROIT DISTINCT ET PERMANENT DE SUPERFICIE)','CHF'] },
                { isSelected: false, data: ['COÛT DE CONSTRUCTION DES LOGEMEMENTS EN PPE','CHF TTC'] },
                { isSelected: false, data: ['COÛT DE CONSTRUCTION DES LOGEMEMENTS LOCATIFS EN MARCHÉ LIBRE','CHF TTC'] },
                { isSelected: false, data: ['COÛT DE CONSTRUCTION DES LLA','CHF TTC'] },
                { isSelected: false, data: ['COÛT DE CONSTRUCTION DES LLM','CHF TTC'] },
                { isSelected: false, data: ['COÛT DE CONSTRUCTION DES ACTIVITÉS EN PPE','CHF TTC'] },
                { isSelected: false, data: ['COÛT DE CONSTRUCTION DES ACTIVITÉS EN LOCATION','CHF TTC'] }
            ]
        };
    },
    computed: {
        ...mapState("referential", ["selectedReferential", "generalDataConfig"]),
        ...mapGetters("referential", ["isReferentialLocked", "generalData"]),
        isLocked() {
            return this.isReferentialLocked(this.selectedReferential)
        },
        sortedChapters() {
            const order = {
                "Surfaces et volumes (référence SIA 416 et SIA 421)": 0,
                "Géométrie du bâtiment": 1,
                "Agents énergétiques":2,
                "Chauffage":3,
                "ECS":4,
                "Froid":5,
                "Informations économiques":7,
                "Stationnement propre au projet":6
            };

            const keys = Object.keys(this.chapters);

            keys.sort((a, b) => {
                return order[a] - order[b];
            });

            return keys.map(key => {
                const items = this.chapters[key]
                const sortedItems = [...items].sort((a,b) => {
                    return a.view_order - b.view_order;
                });
                return [key, sortedItems];
            });
        },
    },
    async mounted() {
        //console.log("state referential:", this.$store.state.referential)
        if(this.selectedReferential === 0) {
            if(this.$route.params.id) {
                this.$store.commit("referential/selectTreeMutation", this.$route.params.id)
            }
            //console.log("loaded referential: ", this.selectedReferential)
        } else {
            //console.log("Referential already loaded")
        }

        try {
            await this.$store.dispatch("referential/getGeneralDataConfig").then(() => {
                //console.log("this.generalDataConfig :",this.generalDataConfig)
                this.chapters = this.generalDataConfig.reduce((acc, item) => {
                    const key = item.locationChapter;
                    if (!acc[key]) acc[key] = [];
                    acc[key].push(item);
                    /* //console.log("key ",acc) */
                    return acc;
                }, {});
                //console.log("chapters:", this.chapters)
            }).catch((error) => {
                console.error("Error loading general data config:", error)
            });
        } catch (error) {
            console.error("Erreur :", error)
        }
    },  
    methods: {
        isChapterChecked(items){
            if(!Array.isArray(items)) return false;
            return items.every(i => !!i.is_visible);
        },
        toggleChapter(items, is_visible){
            if(items)
            items.forEach(i => {
            i.is_visible = is_visible
            ////console.log("i.tag",i.tag, " \n", is_visible)
            this.$store.dispatch("referential/updateGeneralDataConfig", { tag : i.tag, is_visible })
                .then(() => {
                    /* //console.log("General data config updated ", i.tag, "\n", is_visible) */
                    })
                    .catch((error) => {
                        console.error("Error updating general data config:", error)
                        });
            })
        },
        toggleSelected(tag, is_visible) {
            //console.log("toggleSelected", tag, is_visible)
            // this.$store.dispatch("referential/updateTargetVisibility", this.target.filter(item => item.isVisible).map(item => item.data[0]))
            this.$store.dispatch("referential/updateGeneralDataConfig", { tag, is_visible })
                .then(() => {
                    //console.log("General data config updated")
                })
                .catch((error) => {
                    console.error("Error updating general data config:", error)
                });
    },
}
}
</script>

<style scoped>
.general-data-config {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}
table {
    width: 90%;
    border-collapse: collapse;
}
th, td {
    border: 1px solid #ddd;
    padding: 8px;
}
th {
    background-color: #f2f2f2;
}
input[type="checkbox"] {
    margin: 0 auto;
    display: block;
}

h2{
    text-align: left;
}
</style>